import { jsx as _jsx } from "react/jsx-runtime";
import { Text, Youtube } from "@cinch-labs/design-system";
import { BLOK_YOUTUBE, isYoutubeBlok } from "@cinch-nx/data-storyblok";
import { MARK_BOLD, NODE_IMAGE, NODE_PARAGRAPH, render } from "storyblok-rich-text-react-renderer";
import styles from "./rich-text-renderer.module.css";
const resolveYoutubeVideo = (props)=>isYoutubeBlok(props) ? /*#__PURE__*/ _jsx(Youtube, {
        ...props,
        className: styles["video"],
        customThumbnail: props.thumbnail.filename
    }) : null;
export const renderWithResolver = (body, makeId)=>{
    return render(body, {
        nodeResolvers: {
            [NODE_IMAGE]: (_, props)=>/*#__PURE__*/ _jsx("img", {
                    ...props,
                    style: {
                        height: "auto"
                    },
                    alt: props.alt
                }),
            [NODE_PARAGRAPH]: (children)=>children ? /*#__PURE__*/ _jsx(Text, {
                    className: styles["rtParagraph"],
                    children: children
                }) : null
        },
        blokResolvers: {
            [BLOK_YOUTUBE]: (props)=>resolveYoutubeVideo(props)
        },
        ...makeId && {
            markResolvers: {
                [MARK_BOLD]: (children)=>{
                    /*#__PURE__*/ return _jsx("strong", {
                        id: children === null || children === void 0 ? void 0 : children.toLocaleString().replace(/\s/g, ""),
                        children: children
                    });
                }
            }
        }
    });
};
